(function () {
    'use strict';

    angular
        .module('app.floorPlans')
        .controller('FloorPlansListController', FloorPlansListController);

    FloorPlansListController.$inject = ['common', 'dataservice', 'config', '$sce'];
    /* @ngInject */
    function FloorPlansListController(common, dataservice, config, $sce) {
        var vm = this;
        vm.title = "Floor Plans"
        vm.displayedItems = [];
        vm.items = [];
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.safeSvg = safeSvg;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = (
                    vm.licenseInfo.NumberOfDisplaysLicensed >= vm.licenseInfo.NumberOfDisplaysInUse
                    || vm.licenseInfo.NumberOfPaymentTemplatesLicensed >= vm.licenseInfo.NumberOfPaymentTemplatesInUse
                    
                );
                return vm.licenseInfo;
            }, function (error) { });
        }

        function safeSvg(data) {
            return $sce.trustAsHtml(data);
        }

        function getItems() {
            return dataservice.getItems('api/FloorPlans').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }
    }
})();
